import {Lot} from './Lot';
export class TypeLotsMAPA {

	public lot: Lot[];

	public tousLots: string;

	public plusieursLot: string;

	public unLot: string;

	constructor() {
    this.lot = [];
		this.tousLots = null;
		this.plusieursLot = null;
		this.unLot = null;
	}
}
